module.exports = __webpack_public_path__ + "img/avatar-placeholder.32c6fe79.svg";